import { useEffect, useState, useRef } from "react";

// Returns true once window.scrollY passes `threshold`. Uses a single
// rAF-throttled scroll listener (instead of running on every scroll
// event) and a passive listener to avoid blocking the scroll thread.
export function useScrollThreshold(threshold = 20) {
  const [past, setPast] = useState(false);
  const ticking = useRef(false);

  useEffect(() => {
    const onScroll = () => {
      if (ticking.current) return;
      ticking.current = true;
      requestAnimationFrame(() => {
        setPast(window.scrollY > threshold);
        ticking.current = false;
      });
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [threshold]);

  return past;
}
